// extracted by mini-css-extract-plugin
export default {"root":"_3a3p6","large":"SW8cD","medium":"_1hrfm","small":"_3umN-","daily-deviation":"_1v6_r","dailyDeviation":"_1v6_r","hype":"_2Gl0P"};